module.exports = __webpack_public_path__ + "static/media/technical.3941a53b.png";